module.exports = __webpack_public_path__ + "img/8.5d495216.svg";